<template>
    <div>
        <table class="table">
            <thead>
            <tr>
                <th class="mw-70">ID</th>
                <th>Data type</th>
                <th>Last exported time</th>
                <th>Last exported id</th>
                <th>Migrated</th>
                <th>Time start</th>
                <th>Records migrated</th>
                <th>Records count</th>
                <th>Table type</th>
                <th>Count of created records in files</th>
                <th v-if="isMoodle">Actions</th>
            </tr>
            </thead>
            <tbody>
                <tr v-for="(exportlog, index) in exportlogs" :key="exportlog.id">
                    <td>{{ exportlog.id }}</td>
                    <td>{{ exportlog.datatype }}</td>
                    <td>{{ dateFormat(exportlog.last_exported_time) }}</td>
                    <td>{{ exportlog.last_exported_id }}</td>
                    <td>{{ exportlog.migrated }}</td>
                    <td>{{ dateFormat(exportlog.timestart) }}</td>
                    <td>{{ exportlog.recordsmigrated }}</td>
                    <td>{{ exportlog.recordscount }}</td>
                    <td>{{ exportlog.tabletype }}</td>
                    <td>{{ exportlog.count_in_files }}</td>
                    <td v-if="isMoodle">
                        <admin-actions-dropdown>
                            <b-dropdown-item @click="resetDataType(exportlog.datatype)">
                                Reset
                            </b-dropdown-item>
                            <b-dropdown-item :href="route('moodle.edit-datatypes-config', {'datatype': exportlog.datatype, 'connection': connectionId})">
                                Edit
                            </b-dropdown-item>
                        </admin-actions-dropdown>
                    </td>
                </tr>

                <tr v-if="exportlogs.length === 0">
                    <td class="table-empty" colspan="5">No logs!</td>
                </tr>
            </tbody>
        </table>

        <loading-overlay :loading="loading"></loading-overlay>
    </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import route from "ziggy-js";

export default {
    props: {
        exportlogList: {
            type: String,
            default: ''
        },
        connectionId: {
            type: String
        },
        isMoodle: {
            type: String
        }
    },

    data() {
        return {
            exportlogs: {},
            loading: false
        }
    },

    created() {
        this.renderList();
    },

    methods: {
        resetDataType(datatype) {
            if (!confirm('Are you sure want to reset table "' + datatype + '" in LMS?')) {
                return;
            }

            this.loading = true;
            return axios.post(this.route('moodle.reset-datatype', {connection: this.connectionId}), {
                    datatype: datatype
                })
                .then(response => {
                    if (response.status) {
                        this.$notifications.success('Table "' + datatype + '" reseted.');
                    } else {
                        this.$notifications.error('Table "' + datatype + '" not reseted.');
                    }
                    this.loading = false;
                })
        },

        renderList() {
            this.exportlogs = this.exportlogList.length > 0
                ? JSON.parse(this.exportlogList)
                : {};
        },
        dateFormat(date) {
            return (date !=='0') ? moment.unix(date).format('DD MMM YYYY HH:mm:ss') : '-';
        }
    }
}
</script>
